import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
	return {
		navigation: state.initNavigationStore,
	}
}

export const ButtonBack =
    connect(
        (mapStateToProps),
    )(
        withRouter(
            class extends Component {
                render() {
                    const { disabled, location, history } = this.props;
                    
                    return (
                    <div className="back-button">
                        <button
                            type="button"
                            className="button is-secondary"
                            onClick={() => {
                                if (localStorage.getItem('stateParentUrl')) {
                                    const parentUrl = localStorage.getItem('stateParentUrl');
                                    localStorage.removeItem('parentUrl');
                                    history.push(parentUrl);
                                } else if (!this.props.navigation.init) {
                                    history.push(location.state?.backTo || '/');
                                } else if (location.state?.resetSearch) {
                                    history.push(location.state?.backTo || '/');
                                }else {
                                history.goBack();
                                }
                            }}
                            disabled={disabled}
                        >
                            Voltar
                        </button>
                    </div>
                    );
                }
            }
      ) 
    );
